import React from "react";

// License name is a link. It opens a new window: /legal/terms-of-use/#photo-licenses

const CCBasic = () => {
    return (
        <div>
            <div>
                Attributing the artist is required per{" "}
                <a href="/legal/terms-of-use/#photo-licenses" target="_blank">
                    CC BY-NC-ND 2.0 License
                </a>
                .
            </div>
            <div>
                See full{" "}
                <a
                    href="https://creativecommons.org/licenses/by-nc-nd/2.0/"
                    target="_blank"
                >
                    license details
                </a>
                .
            </div>
        </div>
    );
};

export default CCBasic;
